import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";

export default class TowelTowelBar extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "towel_towel_bar";
    this.partName = "Towel";
    this.translateId = "visualizer.bathroom.accessories.towel";
    if (isChild) {
      createParentPositions(this);
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const towelBar = this.getParent().towelBar;
    if (towelBar && towelBar.layerPositions && towelBar.activeFeature) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: towelBar.activeFeature.getSplittedSku()
      });
    }
    return conditions
  }
}
